export default function Pricing() {
  return (
    <section id="pricing" className="py-24 bg-white relative overflow-hidden">
      {/* 배경 장식 */}
      <div className="absolute top-20 right-0 w-96 h-96 bg-orange-100 rounded-full blur-3xl opacity-30"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-50 rounded-full blur-3xl opacity-40"></div>
      
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">이용요금 안내</h2>
          <div className="w-20 h-1 bg-orange-500 mx-auto mb-4"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            시간제 결제 시스템으로 합리적이고 투명한 요금 구조를 제공합니다
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          {/* 메인 이미지 */}
          <div className="relative mb-16">
            <div className="absolute inset-0 bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl transform rotate-1"></div>
            <img 
              src="https://public.readdy.ai/ai/img_res/1c3a7b580297aef4c1accd6304d62cd6.jpg"
              alt="이용요금 시스템"
              className="relative rounded-3xl shadow-2xl w-full h-[350px] object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent rounded-3xl"></div>
            <div className="absolute bottom-8 left-8 text-white">
              <h3 className="text-3xl font-bold mb-2">시간제 결제 시스템</h3>
              <p className="text-lg">간편하고 투명한 요금 구조</p>
            </div>
          </div>
          
          {/* 요금 방식 카드 */}
          <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl p-12 mb-12 text-white shadow-2xl">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold ml-4">요금 방식</h3>
            </div>
            <p className="text-xl leading-relaxed">
              PLAY PLACE는 시간제 결제 후 이용 방식으로 운영됩니다.
            </p>
          </div>
          
          {/* 요금 기준 */}
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-orange-500 hover:shadow-xl transition-shadow">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-store-2-line text-2xl text-orange-500"></i>
                </div>
                <div className="ml-4">
                  <h4 className="text-xl font-bold text-gray-900 mb-3">매장별 요금</h4>
                  <p className="text-gray-600 leading-relaxed">
                    이용 요금은 매장별로 상이할 수 있습니다.
                  </p>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-8 shadow-lg border-l-4 border-orange-500 hover:shadow-xl transition-shadow">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-2xl text-orange-500"></i>
                </div>
                <div className="ml-4">
                  <h4 className="text-xl font-bold text-gray-900 mb-3">세부 요금 안내</h4>
                  <p className="text-gray-600 leading-relaxed">
                    세부 요금은 각 매장 안내를 기준으로 합니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}